import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Modal from '../../../common/modal'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../common/modaltypes'
import { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { cargoServiceTypes, detailColumnsStyles, jsPdfHeaderFooter, rateMatrixDeleteHeader, rateMatrixHistoryFlterHeader, rateMatrixHistoryHeader } from './rateMatrixConstants'
import { getFocApprConsTypeData, getServiceTypeListAllData } from '../../../../store/generalSetting/GSAction'
import { GetKgKmRateMatrixHistoryTblData } from '../../../../store/generalSetting/GSAction'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import { updateModal } from '../../../../store/common/common_action'
import { connect } from 'react-redux'
import moment from 'moment'
import { useTranslation } from '../../../../i18n/I18nProvider'
const KGKMMatrixHistory = (props) => {
  const { data, methods, GetKgKmRateMatrixHistoryTblData, updateModal, getServiceTypeListAllData, getFocApprConsTypeData } = props
  const theme = useTheme()
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const t = (key, fallback) => gs?.[key] || fallback
  const cargoServiceTypeOptions = cargoServiceTypes.map((item) => ({ ...item, name: t(item.translationKey, item.name) }))
  const [selectedServiceType, setSelectedServiceType] = useState({})
  const { headText, isDelete = false, generalSettingReducer, common } = data
  const { loginData } = common
  const { focApprConsTypeData, kgKmRateMatrixData, kgKmRateMatrixHistoryData, serviceTypeListAll } = generalSettingReducer
  let rateMatrixHistoryHeaderCopy = rateMatrixHistoryHeader.map((col) => ({ ...col, headerName: t(col.translationKey, col.headerName) }));
  const [selectedData, setSelectedData] = useState({ cargoServiceType: cargoServiceTypeOptions[0], multiCargoServiceType: '', consType: '' })
  const [showResult, setShowResult] = useState(true)
  const [showTable, setShowTable] = useState(true)
  const [deleteHistoryData, setDeleteHistoryData] = useState([])
  const [consTypeList, setConsTypeList] = useState([])
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load, } = { ...state }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let multiCargoBody = {
        CargoServiceType: selectedData?.cargoServiceType?.id,
        CompanyID: loginData?.intCompanyID,
        IsActive: 1
      }
      getServiceTypeListAllData(multiCargoBody)
    }
  }, [loginData, selectedData?.cargoServiceType])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let obj = {
        intConsignmentSubTypeID: 0,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: "",
        intIsActive: 1,
        intIsDeleted: 0
      }
      getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)
    }
  }, [loginData])
  useEffect(() => {
    if (focApprConsTypeData?.length > 0) {
      let newData = [{ id: 0, name: t('all', 'All'), translationKey: 'all' }]
      focApprConsTypeData.map(function (obj) {
        newData.push({
          id: obj.ConsignmentSubTypeID,
          name: obj.SubType,
        })
      })
      newData = removeDuplicatesFromArray(newData, `id`)
      newData.sort((a, b) => a.name.localeCompare(b.name))
      setConsTypeList(newData)
      setSelectedData((prev) => ({
        ...prev,
        consType: newData.find((item) => item.id === prev?.consType?.id) || prev.consType
      }))
    } else {
      setConsTypeList([])
    }
  }, [focApprConsTypeData, translations])

  useEffect(() => {
    // if (kgKmRateMatrixHistoryData.length>0) {
    const updatedData = kgKmRateMatrixHistoryData?.map((val, index) => ({ ...val, SN: index + 1, EntryDateTime: moment(val.EntryDateTime).format('HH:mm DD MMM-YY') }))
    setDeleteHistoryData(updatedData)
    // }
  }, [kgKmRateMatrixHistoryData])

  if (isDelete) {
    rateMatrixHistoryHeaderCopy = rateMatrixHistoryHeaderCopy
      .filter((item) => item.field !== 'OldRate' && item.field !== 'OldDocumentCharge')
      .map((header) => {
        if (header.field === 'NewRate' || header.translationKey === 'newRate') {
          return { ...header, headerName: t('rate', 'Rate'), translationKey: 'rate' };
        } else if (header.field === 'NewDocumentCharge' || header.translationKey === 'newDocChrg') {
          return { ...header, headerName: t('docChargeShort', 'Doc. Charge'), translationKey: 'docChargeShort' };
        }
        return header;
      });
  }

  // const { updateModal } = methods
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  const handleLoadBtn = () => {
    const obj = {
      CompanyID: loginData?.intCompanyID,
      CargoServiceType: selectedData.cargoServiceType.id,
      ServiceTypeID: selectedData.multiCargoServiceType.ServiceTypeID,
      ConsignmentID: selectedData.consType.id
    }
    GetKgKmRateMatrixHistoryTblData(obj)
    setShowResult(true)
  }
  const clickElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
  }
  const headerData = {
    cargoType: selectedData?.cargoServiceType?.name,
    multiCargoType: selectedData.multiCargoServiceType.ServiceType,
    consType: selectedData.consType.name,
  }
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const HeaderColumns = rateMatrixHistoryFlterHeader.map((col) => {
      return { header: t(col.translationKey, col.headerName), dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = rateMatrixHistoryHeader.map((col) => {
      return { header: t(col.translationKey, col.headerName), dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${t('kgKmMatrixHistory', 'KG KM Matrix History')}.pdf`,
      subject: t('kgKmMatrixHistory', 'KG KM Matrix History'),
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [headerData],
      columnStyles: {
        0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      // didDrawPage: function (data) {
      //   doc.setTextColor(0, 0, 0)
      //   doc.setFontSize(18).setFont('Roboto', 'bold')
      //   doc.text(`Booking Date : ${headerData?.fromDate}  To  ${headerData.toDate}`, data.settings.margin.left, 150)
      //   doc.text(`Report: ${headerData.reportOptions}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
      // },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: deleteHistoryData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      theme: 'grid',
      columnStyles: detailColumnsStyles,
      didParseCell: (data) => {
        // DetailsDrawCell(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(t('cargoSystemKgKmMatrixHistory', 'Cargo System |  KG KM Matrix History'), 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`${t('companyName', 'Company Name')} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    // if (isSave) {
    //   doc.save(`KG KM Matrix History ${new Date().getTime()}.pdf`)
    //   setTimeout(() => {
    //     setState({ ...state, generatePDF: false, load: true })
    //     document.getElementById('KgKamHitoryMatrix').data = doc.output('datauristring', ' KG KM Matrix History')
    //     // focusElemnt("backBtn")
    //   }, 2000)
    // } else {
    setState({ ...state, generatePDF: false, load: true })
    setTimeout(() => {
      // document.getElementById('KgKamHitoryMatrix').data = doc.output('datauristring', ' KG KM Matrix History')
      document.getElementById('KgKamHitoryMatrix').data = doc.output('datauristring', 'Item List.pdf')
      // focusElemnt("backBtn")
    }, 2000)

    // }
  }
  return (
    <Modal
      headTxt={headText || t('kgKmMatrixHistory', 'KG KM Matrix History')}
      width={'95%'}
      updateModal={updateModal}
      height={deleteHistoryData.length > 15 ? '80%' : undefined}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <div style={{ position: 'relative', height: 'calc(100% - 53px)' }}>
        {
          showTable ?
            <>
              <Grid container sx={{ display: 'flex', gap: '16px', padding: '12px 15px 4px 15px' }}>
                <Item sx={sx.itemsxGrow}>
                  <DropDownOA
                    id={'Cargo_Service_Type'}
                    label={t('cargoServiceType', 'Cargo Service Type')}
                    data={cargoServiceTypeOptions}
                    defaultvalue={selectedData?.cargoServiceType?.name || ''}
                    value={selectedData?.cargoServiceType?.name || ''}
                    onSelect={(val) => {
                      setShowResult(false)
                      setSelectedData((prev) => ({
                        ...prev,
                        cargoServiceType: val
                      }))
                    }}
                    idKey={`id`}
                    dataKey={`name`}
                    minWidth={"100%"}
                    nextId={``}
                    prevId={``}
                  />
                </Item>
                <Item sx={sx.itemsxGrow}>
                  <DropDownOA label={t('multiCargoServiceType', 'Multi Cargo Service Type')}
                    data={serviceTypeListAll || []}
                    defaultvalue={selectedData?.multiCargoServiceType?.ServiceType || ''}
                    value={selectedData?.multiCargoServiceType?.ServiceType || ''}
                    width="100%"
                    searchPlaceholder={t('searchServiceType', 'Search Service Type')}
                    dataKey={`ServiceType`}
                    idKey={`ServiceTypeID`}
                    listWidth="200px"
                    // resetFlag={resetFilter}
                    onSelect={(val) => {
                      setShowResult(false)
                      setSelectedData((prev) => ({
                        ...prev,
                        multiCargoServiceType: val
                      }))
                    }}
                  />
                </Item>
                <Item sx={sx.itemsxGrow}>
                  <DropDownOA
                    key={`consignmentType-${language}-${selectedData?.consType?.id}-${selectedData?.consType?.name}`}
                    id='ConsType'
                    label={t('consignmentType', 'Consignment Type')}
                    data={consTypeList || []}
                    defaultvalue={selectedData?.consType?.name || ''}
                    value={selectedData?.consType?.name || ''}
                    width="100%"
                    searchPlaceholder={t('searchConsignmentType', 'Search Consignment Type')}
                    dataKey={`name`}
                    idKey={`id`}
                    listWidth="200px"
                    // resetFlag={resetFilter}
                    onSelect={(val) => {
                      setShowResult(false)
                      setSelectedData((prev) => ({
                        ...prev,
                        consType: val
                      }))
                    }}
                    nextId=''
                    prevId={``}
                  />
                </Item>
                <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                  <Button
                    variant="contained"
                    onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => { })}
                    id={'search_btn'}
                    sx={{ width: '100%', paddingY: '6px !important' }}
                    className="btn btn-primary"
                    onClick={() => handleLoadBtn()}
                  >
                    {t('load', 'Load')}
                  </Button>
                </Item>
              </Grid>
              {
                showResult &&
                <Grid container sx={{ paddingX: '15px', marginBottom: '10px', height: 'calc(100% - 120px)' }}>
                  <TableContainer component={Paper} className="scroll" sx={{ marginY: '5px', height: '100%' }}>
                    <Table
                      id='table-to-xls'
                      stickyHeader
                      size="small"
                      aria-label="a dense table"
                      sx={{
                        '& .MuiTableCell-root': {
                          padding: '6px 4px !important',
                        },
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          {rateMatrixHistoryHeaderCopy.map((row, index) => {
                            return (
                              <TableCell
                                sx={{
                                  ...row.headerSx,
                                  backgroundColor: '#DAEDFE',
                                  height: '30px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#444',
                                  fontSize: '12px',
                                }}
                              >
                                {row.headerName}
                              </TableCell>
                            )
                          })}
                        </TableRow>
                      </TableHead>
                      {
                        deleteHistoryData?.length < 1 ?
                          <TableBody>
                            <TableRow>
                              <TableCell colSpan={15}>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '20px',
                                    marginBottom: '20px',
                                    color: 'red',
                                    fontSize: '20px',
                                    lineheight: '16px',
                                    letterspacing: '0.24px',
                                  }}
                                >
                                  <span>{t('noResultsRefineSearch', 'No results found. Please refine your search parameters and search again.')}</span>
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableBody> :
                          <TableBody>
                            {deleteHistoryData.map((item, index) => (
                              <TableRow key={`DR-${index}`}>
                                {rateMatrixHistoryHeaderCopy.map((col) => (
                                  <TableCell sx={{ ...col.headerSx, height: '29px', fontSize: '12px', fontWeight: '400' }}>{item[col.field]}</TableCell>
                                ))}
                              </TableRow>
                            ))}
                          </TableBody>
                      }

                    </Table>
                  </TableContainer>
                </Grid>
              }
              {
                showTable &&
                <Grid container sx={{ display: 'flex', gap: '16px', padding: '5px 15px 15px 15px', justifyContent: 'flex-end' }}>
                  <Item sx={{ ...sx.itemsx }} className="">
                    <Button
                      variant="outlined"
                      id={'add_btn'}
                      color="secondary"
                      sx={{ width: '100%', fontSize: '16px' }}
                      className="receiveitembtn"
                      onClick={() => { clickElement('test-table-xls-button') }}
                    >
                      {t('exportAsExcel', 'EXPORT AS EXCEL')}
                    </Button>
                    <Box sx={{ display: 'none' }}>
                      <ReactHtmlTableToExcel
                        id="test-table-xls-button"
                        className="receiveitembtn"
                        table="table-to-xls"
                        filename="Franchisee Booking Report"
                        sheet="tablexls"
                        buttonText={t('exportToExcel', 'Export to Excel')}
                      />
                    </Box>
                  </Item>
                  <Item sx={{ ...sx.itemsx }} className="">
                    <Button
                      variant="contained"
                      id={'add_btn'}
                      color="secondary"
                      sx={{ width: '100%', fontSize: '16px' }}
                      className="receiveitembtn"
                      onClick={() => { printClick(false); setShowTable(false) }}
                    >
                      {t('print', 'PRINT')}
                    </Button>
                  </Item>
                </Grid>
              }
            </>
            :
            <Box>
              <Button
                variant="outlined"
                id="backBtn"
                color="secondary"
                sx={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }}
                className="receiveitembtn"
                onClick={() => { setShowTable(true) }}
              // onKeyDown={(e) => navigation3(e, id.fromDate, id.reportmainButton, () => { setSearchResult(true); setLargePDF(false); focusElemnt(id.reportmainButton) })}
              >
                {t('back', 'Back')}
              </Button>
            </Box>
        }
        {
          state.generatePDF ? <div className={'generatePDF'}>{t('generatingPdf', 'Generating PDF....')}</div> : ''
        }
        {
          state.load &&
          <object
            id="KgKamHitoryMatrix"
            type="application/pdf"
            width={"100%"}
            height="440"
            title={`MTLPL -Cargo System -${t('kgKmMatrixHistory', 'KG KM Matrix History')}`}
            aria-label={`MTLPL -Cargo System -${t('kgKmMatrixHistory', 'KG KM Matrix History')}`}
          ></object>
        }

      </div>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, GetKgKmRateMatrixHistoryTblData, getServiceTypeListAllData, getFocApprConsTypeData }
export default connect(mapStateToProps, mapDispatchToProps)(KGKMMatrixHistory)
// export default KGKMMatrixHistory
